import * as XLSX from "xlsx";
import config from "../../config";
import { authFetch } from "../Security/authFetch";

export const handleExcelUpload = async (
  e: React.ChangeEvent<HTMLInputElement>
) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = async (evt) => {
    const binaryStr = evt.target?.result;
    const workbook = XLSX.read(binaryStr, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    try {
      const response = await authFetch(
        `${config.apiBaseUrl}/api/incidents/import`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(jsonData),
        }
      );

      if (response.ok) {
        alert("✅ Excel uploaded and DAG triggered!");
      } else {
        alert("❌ Failed to trigger DAG.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("❌ An error occurred while uploading the file.");
    }
  };

  reader.readAsBinaryString(file);
};
